// extracted by mini-css-extract-plugin
export var compactFilters = "_eg-4";
export var detailImage = "_eg-1";
export var dropdownContainer = "_eg-2";
export var imageContainer = "_eg-0";
export var selectedCard = "_eg-3";